import { render } from "./c-preferred-officers.vue?vue&type=template&id=07378e67"
import script from "./c-preferred-officers.vue?vue&type=script&lang=js"
export * from "./c-preferred-officers.vue?vue&type=script&lang=js"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__